import { forwardRef } from "react";
import { LevelCustomerMapping } from "./LevelCustomerMapping";
import { LevelDeviceMapping } from "./LevelDeviceMapping";
import { ChooseLevelDefaultBoard } from "./ChooseLevelDefaultBoard";

export const LevelMainWrapper = forwardRef(
  (
    {
      step,
      onStepChange,
    }: { step: number; onStepChange: (step: number) => void },
    ref,
  ) => {
    switch (step) {
      case 1:
        return (
          <ChooseLevelDefaultBoard ref={ref} onStepChange={onStepChange} />
        );
      case 2:
        return <LevelCustomerMapping ref={ref} onStepChange={onStepChange} />;
      case 3:
        return <LevelDeviceMapping ref={ref} onStepChange={onStepChange} />;
      default:
        return (
          <ChooseLevelDefaultBoard ref={ref} onStepChange={onStepChange} />
        );
    }
  },
);
